import React from 'react';
import Select, { SelectClassKey, SelectProps } from '@material-ui/core/Select';
import KeyboardArrowDownRounded from '@material-ui/icons/KeyboardArrowDownRounded';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { InputBaseProps } from '@material-ui/core/InputBase/index';
import { MenuItemProps } from '@material-ui/core/MenuItem';
import { FormControlClassKey } from '@material-ui/core';
import { ClassNameMap } from '@material-ui/styles';
import withThemeProvider from '../util/withThemeProvider';
import FormContainer, { FormContainerProps } from './FormContainer';

export type DropdownProps = {
  placeholder?: string;
  selectClasses?: Partial<ClassNameMap<SelectClassKey>> | undefined;
  formControlClasses?: Partial<ClassNameMap<FormControlClassKey>> | undefined;
  customInputBase?: React.ReactElement<InputBaseProps>;
  children: React.ReactElement<MenuItemProps> | React.ReactElement<MenuItemProps>[];
} & SelectProps &
  FormContainerProps;

const Dropdown = ({
  disabled,
  label,
  placeholder,
  error,
  message,
  customInputBase,
  selectClasses,
  formControlClasses,
  ...rest
}: DropdownProps) => {
  return (
    <FormContainer
      classes={formControlClasses}
      disabled={disabled}
      error={error}
      fullWidth={rest.fullWidth}
      label={label}
      message={message}
    >
      <Select
        classes={selectClasses}
        IconComponent={KeyboardArrowDownRounded}
        // this is a workaround for a bug in material-ui. Once on the current version, replace with variant="outlined".
        input={customInputBase || <OutlinedInput labelWidth={0} />}
        // these menu props make the menu items unfurl under the input instead of on top of it
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
        {...rest}
      />
    </FormContainer>
  );
};

export default withThemeProvider(Dropdown);

//to be used with MaterialUi MenuItem children.
